import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useState } from "react";

import { MoreHoriz } from "@mui/icons-material";
import { useGetSourceDataRecord } from "src/views/datasets/services/DatasetServices";

type SourceDetailViewProps = {
  sdrId: number | null;
};

const SourceDetailView = ({ sdrId }: SourceDetailViewProps) => {
  // TODO: get this from the cache
  const { data: sourceDataRecord } = useGetSourceDataRecord(sdrId);

  const [expandedItems, setExpandedItems] = useState<{
    [key: number]: boolean;
  }>({});

  const handleToggle = (index: number) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const truncateText = (text: string, length: number) => {
    return text.length > length ? text.slice(0, length) + "..." : text;
  };

  return (
    <Box>
      <Grid
        container
        rowSpacing={2}
        columnSpacing={1}
        sx={{
          paddingLeft: 2,
          paddingY: 1,
          width: "100%",
          "--Grid-borderWidth": "1px",
          borderTop: "var(--Grid-borderWidth) solid",
          borderLeft: "var(--Grid-borderWidth) solid",
          borderColor: "divider",
          "& > div": {
            borderRight: "var(--Grid-borderWidth) solid",
            borderBottom: "var(--Grid-borderWidth) solid",
            borderColor: "divider",
          },
        }}
      >
        {sourceDataRecord &&
          Object.entries(sourceDataRecord.data).map(([key, value], i) => {
            const isExpanded = expandedItems[i];
            const displayValue: React.ReactNode =
              typeof value === "string"
                ? isExpanded
                  ? value
                  : truncateText(value, 100)
                : (value as React.ReactNode);
            return (
              <React.Fragment key={i}>
                <Grid item xs={3}>
                  <Typography
                    variant="body2"
                    fontWeight="bold"
                    sx={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      pr: 0.5,
                    }}
                  >
                    {key}
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Box>
                    {displayValue || "-"}
                    {typeof value === "string" && value.length > 100 && (
                      <Button
                        color="primary"
                        variant="text"
                        onClick={() => handleToggle(i)}
                        startIcon={<MoreHoriz fontSize="small" />}
                      >
                        {isExpanded ? "Less" : "More"}
                      </Button>
                    )}
                  </Box>
                </Grid>
              </React.Fragment>
            );
          })}
      </Grid>
    </Box>
  );
};

export default SourceDetailView;
